
const login = {
  set component(comp) {
    throw new Error('The `login.component` configuration from `@/authentication/config` is deprecated. Use `registerLoginPage` from `@/authentication/config/login-pages` instead.');
  },
  get component() {
    throw new Error('The `login.component` configuration from `@/authentication/config` is deprecated. Use `registerLoginPage` from `@/authentication/config/login-pages` instead.');
  },
};

export const loginContactWithUsMailAddress = '';

export default {
  login,
  loginContactWithUsMailAddress,
};
